import XLSX from '@sheet/core';

/**
 *
 * @param {Array<string>} cols - column titles
 * @param {Array<Array<string>>|Array<object>} rows - 2dim array of string values matching cols structure
 * @param {string} sheetTitle - title of the sheet - default: APCIA Export
 * @param {string} fileName - file name. default: sheet.xlsx
 */
export default async function exportToExcel(
  cols,
  data,
  sheetTitle = 'APCIA Export',
  fileName = 'sheet.xlsx'
) {
  // make each column the width of its widest cell

  /**
   * @param {Array<Array<string>>} arrayOfArray -
   * @returns {Array<object>} configuration for column width [{wch: number}]
   */
  function fitToColumn(arrayOfArray) {
    // get maximum character of each column
    return arrayOfArray[0].map((a, i) => {
      return {
        wch: Math.min(
          50,
          Math.max(...arrayOfArray.map(a2 => (a2[i] ? a2[i].toString().length : ''))) + 5
        ),
      };
    });
  }

  // converts multi-dem array to an xlsx worksheet
  const worksheet = XLSX.utils.aoa_to_sheet([cols, ...data]);
  worksheet['!cols'] = fitToColumn([cols, ...data]);

  const headerRow = XLSX.utils.decode_range(worksheet['!ref']);
  headerRow.s.r = 0;
  headerRow.e.r = 0; // restrict to the first row

  XLSX.utils.sheet_set_range_style(worksheet, headerRow, {
    bold: true,
    name: 'Calibri',
    sz: 12,
    alignment: { horizontal: 'center' },
    fgColor: { rgb: 0xf2f2f2 },
    bottom: { style: 'thin', rgb: 0x000000 },
    right: { style: 'thin', rgb: 0x000000 },
    left: { style: 'thin', rgb: 0x000000 },
    incol: { style: 'thin', rgb: 0x000000 },
  });

  const bodyRows = XLSX.utils.decode_range(worksheet['!ref']);
  bodyRows.s.r = 1;

  XLSX.utils.sheet_set_range_style(worksheet, bodyRows, {
    name: 'Calibri',
    sz: 11,
    alignment: { horizontal: 'left', vertical: 'top', wrapText: true },
  });

  // create a workbook
  const workbook = XLSX.utils.book_new();
  // adds the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetTitle);
  XLSX.writeFile(workbook, `${fileName}.xlsx`, { cellStyles: true });
}
